import { t } from '@/i18n'

export interface ModelType {
  name: string
  taskInfoExpanded: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }
      | {
          device_ip: string
          device_brand: string
        }
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string; deepType?: { item: string } }[]
      | {
          key: string
          deepType: {
            value: string
            type: string
          }
        }
    type: string
    class?: string
    deepType?:
      | {
          id: string
          name: string
        }
      | { device_ip: string; device_brand: string }
      | { item: string }
      | { deviceType: string; deviceIp: string; deviceName: string }
  }[]
  taskInfo: {
    key: string
    value:
      | string
      | {
          id: string
          name: string
        }[]
      | { [key: string]: string | number }
      | string[]
      | { value: string | number; type: string; default?: string }[]
    type: string
  }[]
}

export const getDisplayModel = (): ModelType => ({
  name: 'TS',
  taskInfoExpanded: [
    {
      key: t('模式名称'),
      value: 'mode',
      type: 'string',
    },
    {
      key: t('Agent名称'),
      value: {
        key: 'verificationInfo',
        deepType: {
          value: 'srcAgentName',
          type: 'string',
        },
      },
      type: 'object',
    },
    {
      key: t('安全域'),
      value: {
        key: 'verificationInfo',
        deepType: {
          value: 'srcBizAreaName',
          type: 'string',
        },
      },
      type: 'object',
    },
    {
      key: t('Agent名称'),
      value: {
        key: 'verificationInfo',
        deepType: {
          value: 'dstAgentName',
          type: 'string',
        },
      },
      type: 'object',
    },
    {
      key: t('安全域'),
      value: {
        key: 'verificationInfo',
        deepType: {
          value: 'dstBizAreaName',
          type: 'string',
        },
      },
      type: 'object',
    },
    {
      key: t('过程节点'),
      value: {
        key: 'verificationInfo',
        deepType: {
          value: 'middleIps',
          type: 'array',
        },
      },
      type: 'object',
    },
    {
      key: t('任务分组'),
      value: 'group_name',
      type: 'string',
    },
    {
      key: t('执行类型'),
      value: [
        {
          value: 'scheduler_type',
          type: 'string',
          default: t('立即'),
        },
        {
          value: 'task_time_list',
          type: 'array',
          deepType: {
            item: 'string',
          },
        },
      ],
      type: 'array',
    },
    {
      key: t('任务优先级'),
      value: 'priority',
      type: 'number|string',
    },
    {
      key: t('创建时间'),
      value: 'create_time',
      type: 'string',
    },
    {
      key: t('任务模板'),
      value: 'templates',
      type: 'array',
      deepType: {
        item: 'string',
      },
    },
    {
      key: t('安全设备'),
      value: 'devices',
      type: 'array',
      deepType: {
        deviceType: 'string',
        deviceIp: 'string',
        deviceName: 'string',
      },
    },
  ],
  taskInfo: [
    {
      key: t('进度信息'),
      value: [
        {
          value: 'result_status',
          type: 'number',
        },
        {
          value: 'progress_rate',
          type: 'number',
        },
        {
          value: 'execute_sum',
          type: 'number',
        },
        {
          value: 'fail_sum',
          type: 'number',
        },
      ],
      type: 'array',
    },
  ],
})

export const displayModel = getDisplayModel()

export interface PluginDetailProps {
  id: string
  plugin_name: string
  supported_architectures: string[]
  supported_platforms: string[]
  params: {
    key: string
    value: string
    type: string
    description: string
  }[]
  tactic_list: { name: string; url: string }[]
  intercept_status: number
  risk_level: number
  attack_type: number
  attack_name: string
  describe: string
  solution: string
  apt_list: string[]
  update_time: string
  device_security: any[]
  plugin_log: any
  samples_list: { id: string; samples_name: string; samples_path: string; samples_sha256: string }[]
  principle: string
  start_time: string
  end_time: string
  resource_tag_list: V1TagCategory[]
  intercept_from: string
}

export interface V1TagCategory {
  tagCategoryName?: string
  tagName?: string[]
  [property: string]: any
}
